<template>
    <section class="section section6">
      <div class="section-wrap">
        <div class="s6-text">
          <h2 class="s6-title">{{$t('home.s6_1')}}</h2>
          <p class="s6-ps">{{$t('home.s6_2')}}</p>
        </div>
        <div class="s6-logo-wrap">
          <swiper v-if="logoFormatList.length > 0" :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="item in logoFormatList" class="clearfix">
              <div v-for="child in item" class="logo-box" :style="{backgroundImage:'url(' + child.imgUrl + ')'}"></div>
            </swiper-slide>
          </swiper>
          <div v-show="logoFormatList.length > 1" class="page-num">
            <a-icon type="arrow-left" class="point-icon point-left" />
            <a-icon type="arrow-right" class="point-icon point-right" />
            <span class="page-num-now">{{swiperIndex}}</span> <span class="page-num-total"> / {{logoFormatList.length}}</span>
          </div>
        </div>
      </div>
    </section>
</template>

<script>


  export default {
    name: 'homeSection6',
    data () {
      return {
        swiperIndex: 1,
        swiperOption: {
          speed: 300,
          grabCursor: true,
          paginationClickable: true,
          nextButton: '.point-right',
          prevButton: '.point-left',
          onSlideChangeStart: swiper => {
            let num = swiper.realIndex + 1
            this.swiperIndex = num
          }
        },
        logoList: [{
          id: 1,
          imgUrl: require('@/assets/images/companylogo/1.png')
        },{
          id: 2,
          imgUrl: require('@/assets/images/companylogo/2.png')
        },{
          id: 3,
          imgUrl: require('@/assets/images/companylogo/3.png')
        },{
          id: 4,
          imgUrl: require('@/assets/images/companylogo/4.png')
        },{
          id: 5,
          imgUrl: require('@/assets/images/companylogo/5.png')
        },{
          id: 6,
          imgUrl: require('@/assets/images/companylogo/6.png')
        },{
          id: 7,
          imgUrl: require('@/assets/images/companylogo/7.png')
        },{
          id: 8,
          imgUrl: require('@/assets/images/companylogo/8.png')
        },{
          id: 9,
          imgUrl: require('@/assets/images/companylogo/9.png')
        },{
          id: 10,
          imgUrl: require('@/assets/images/companylogo/10.png')
        },{
          id: 11,
          imgUrl: require('@/assets/images/companylogo/11.png')
        },{
          id: 12,
          imgUrl: require('@/assets/images/companylogo/12.png')
        }],
        logoFormatList: []
      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {
        let formatList = []
        this.logoList.forEach((val,index) => {
          let num = Math.floor(index / 12)
          if (typeof formatList[num] === 'object') {
            formatList[num].push(val)
          } else {
            formatList[num] = []
            formatList[num].push(val)
          }
        })
        this.logoFormatList = formatList

      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .section6
    rela();background-image url("~@/assets/images/home/6-bg.png");bgCover()
    .section-wrap
      height: 8.28rem;padding-top 1.1rem
      .s6-title
        text-align center;font-size .36rem;color #fff
      .s6-ps
        text-align center;margin-top .05rem;font-size .14rem;color #fff
  .s6-logo-wrap
    margin-top .34rem;width: 100%
  .logo-box
    fl();margin-left 2%;margin-top 2%;width: 15%;padding-top 15%;border-radius .05rem;background-repeat no-repeat;background-position center center;background-size 1.4rem;background-color #fff
  .logo-box:nth-child(6n+1)
    margin-left 0

  .page-num
    abso();bottom .64rem;left 0;right 0;margin: auto;width: 1.1rem;height: .2rem;text-align center;line-height .2rem;color #fff;z-index 1
  .page-num-now
    font-size .16rem
  .page-num-total
    font-size .12rem
  .point-icon
    display inline-block;abso();top .03rem;bottom 0;margin: auto;width: .2rem;height: .2rem;font-size .16rem;cursor pointer
  .point-left
    left 0;
  .point-right
    right 0
</style>
